export interface IHeaderProps {
  show: any;
  changeLocation: (url: String) => {};
  showSidebar: (show: boolean) => {};
  logout: () => {};
}

export enum IEnvironmentType {
  PRODUCTION = "PRODUCTION",
  INTEGRATION = "INTEGRATION",
  STAGING = "STAGING",
}
